import RecoveryForm from './RecoveryForm';

export default RecoveryForm;
